import { useContext } from 'react';

import {
  type DatabaseContent,
  DatabaseContentContext
} from '../context/DatabaseContentContext';

export const useDatabaseContent = (): DatabaseContent => {
  const context = useContext(DatabaseContentContext);

  if (context === undefined) {
    throw new Error(
      'useDatabaseContent must be used within a DatabaseContentContext.Provider'
    );
  }

  return context;
};

export default useDatabaseContent;
